<template>
  <div v-if="visible" class="alert-overlay" @click="handleOverlayClick">
    <div class="alert-dialog" @click.stop>
      <div class="alert-header">
        <h3 :class="headerClass">{{ title }}</h3>
      </div>
      <div class="alert-body">
        <p>{{ message }}</p>
      </div>
      <div class="alert-footer">
        <el-button @click="handleCancel">{{ cancelText }}</el-button>
        <el-button :type="confirmType" @click="handleConfirm">{{ confirmText }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'ยืนยัน'
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'ยืนยัน'
    },
    cancelText: {
      type: String,
      default: 'ยกเลิก'
    },
    confirmType: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'danger'].includes(value)
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    headerClass() {
      return {
        'header-primary': this.confirmType === 'primary',
        'header-danger': this.confirmType === 'danger'
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.alert-dialog {
  background: white;
  border-radius: var(--size-sm);
  padding: var(--size-lg);
  min-width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.alert-header h3 {
  margin: 0 0 var(--size-md) 0;
  font-size: 1.1rem;
  font-weight: 600;

  &.header-primary {
    color: #fa7516;
  }

  &.header-danger {
    color: #f56c6c;
  }
}

.alert-body p {
  margin: 0 0 var(--size-lg) 0;
  color: #606266;
  line-height: 1.5;
}

.alert-footer {
  display: flex;
  gap: var(--size-sm);
  justify-content: flex-end;
}

.alert-footer .el-button {
  margin: 0;
  border: 1px solid #d1d5db;
  background: transparent;
  color: #6b7280;
  transition: all 0.3s ease;
}

.alert-footer .el-button:hover {
  background-color: rgba(107, 114, 128, 0.1);
  border-color: #9ca3af;
  color: #374151;
}

.alert-footer .el-button--primary {
  background-color: #fa7516;
  border-color: #fa7516;
  color: white;
}

.alert-footer .el-button--primary:hover {
  background-color: #fb9044;
  border-color: #fb9044;
  color: white;
}

.alert-footer .el-button--danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: white;
}

.alert-footer .el-button--danger:hover {
  background-color: #f78989;
  border-color: #f78989;
  color: white;
}

@media screen and (max-width: 480px) {
  .alert-dialog {
    min-width: 300px;
    padding: var(--size-md);
  }
}
</style>
